import React, {FC, useEffect, useState} from 'react'
import { OrgDepartmentTable } from './components/OrgDepartmentTable';
import axios from 'axios'
import { useParams } from 'react-router-dom';
import { Auth } from 'aws-amplify';

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND



export const GET_ALL_BRANCHES_URL = `${API_URL_API}/branch`


const OrgDepartmentListPage: FC = () => {

  const [loading, SetLoading] = useState(true);
  const [branch, setBranch] = useState({});
  let params = useParams();
  useEffect(() => {
    getAllDepartments();
  },[])


  const getAllDepartments = async () => {
    
    try {

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken();

      

      const {data: result} = await axios.get(GET_ALL_BRANCHES_URL + `/${params.branch_id}/departments`,{
        headers : {
          Authorization: `Bearer ${token}`
        }
      });
        setBranch(result.data);
        console.log(result.data)
        SetLoading(false);
    } catch (err) {
      console.log(err)
    }     
  };

    return (
        <>
        {
          loading ? (
            <div className='d-flex flex-center'>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
            </div>
          ) : (
            <OrgDepartmentTable branch={branch} getAllDepartments={getAllDepartments} className='mb-5 mb-xl-8' />
          )
        }

          
        </>
  )
}

export {OrgDepartmentListPage}
